var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OfferTypes } from '../../../core/types';
import { PaymentMethod } from '../constants';
var filterIncentiveOffers = function (offers) {
    return offers.filter(function (offer) {
        return [OfferTypes.NonStackableRebate, OfferTypes.StackableRebate].includes(offer.type);
    });
};
export var filterSpecialPaymentOffers = function (offerGroups, selectOnlyLoyaltyOffers) {
    if (selectOnlyLoyaltyOffers === void 0) { selectOnlyLoyaltyOffers = false; }
    return offerGroups
        .map(function (offerGroup) {
        var _a, _b, _c;
        var incentiveOffers = offerGroup.incentiveOffers;
        return __assign(__assign({}, offerGroup), { incentiveOffers: __assign(__assign({}, incentiveOffers), { cash: filterIncentiveOffers((_a = incentiveOffers.cash) !== null && _a !== void 0 ? _a : []), finance: filterIncentiveOffers((_b = incentiveOffers.finance) !== null && _b !== void 0 ? _b : []), lease: filterIncentiveOffers((_c = incentiveOffers.lease) !== null && _c !== void 0 ? _c : []) }) });
    })
        .filter(function (offerGroup) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        var hasLoyaltyOffer = ((_b = (_a = offerGroup.loyaltyOffers) === null || _a === void 0 ? void 0 : _a.finance) === null || _b === void 0 ? void 0 : _b.length) ||
            ((_d = (_c = offerGroup.loyaltyOffers) === null || _c === void 0 ? void 0 : _c.lease) === null || _d === void 0 ? void 0 : _d.length) ||
            ((_f = (_e = offerGroup.loyaltyOffers) === null || _e === void 0 ? void 0 : _e.cash) === null || _f === void 0 ? void 0 : _f.length);
        if (selectOnlyLoyaltyOffers)
            return hasLoyaltyOffer;
        var hasIncentiveSpecialOffer = ((_h = (_g = offerGroup.incentiveOffers) === null || _g === void 0 ? void 0 : _g.finance) === null || _h === void 0 ? void 0 : _h.length) ||
            ((_k = (_j = offerGroup.incentiveOffers) === null || _j === void 0 ? void 0 : _j.lease) === null || _k === void 0 ? void 0 : _k.length) ||
            ((_m = (_l = offerGroup.incentiveOffers) === null || _l === void 0 ? void 0 : _l.cash) === null || _m === void 0 ? void 0 : _m.length);
        var hasSpecialRateOffers = ((_p = (_o = offerGroup.specialRateOffers) === null || _o === void 0 ? void 0 : _o.finance) === null || _p === void 0 ? void 0 : _p.length) || ((_r = (_q = offerGroup.specialRateOffers) === null || _q === void 0 ? void 0 : _q.lease) === null || _r === void 0 ? void 0 : _r.length);
        return hasLoyaltyOffer || hasIncentiveSpecialOffer || hasSpecialRateOffers;
    });
};
export var filterTrimsWithValidSpecialOffers = function (trimsWithOffers, selectOnlyLoyaltyOffers) {
    if (selectOnlyLoyaltyOffers === void 0) { selectOnlyLoyaltyOffers = false; }
    return trimsWithOffers.filter(function (trim) {
        return [PaymentMethod.cash, PaymentMethod.lease, PaymentMethod.finance].some(function (paymentMethod) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (selectOnlyLoyaltyOffers)
                return (_b = (_a = trim.offers.loyaltyOffers) === null || _a === void 0 ? void 0 : _a[paymentMethod]) === null || _b === void 0 ? void 0 : _b.length;
            return (((_d = (_c = trim.offers.incentiveOffers) === null || _c === void 0 ? void 0 : _c[paymentMethod]) === null || _d === void 0 ? void 0 : _d.length) ||
                ((_f = (_e = trim.offers.loyaltyOffers) === null || _e === void 0 ? void 0 : _e[paymentMethod]) === null || _f === void 0 ? void 0 : _f.length) ||
                ((_h = (_g = trim.offers.bonusOffers) === null || _g === void 0 ? void 0 : _g[paymentMethod]) === null || _h === void 0 ? void 0 : _h.length) ||
                ((_k = (_j = trim.offers.specialRateOffers) === null || _j === void 0 ? void 0 : _j[paymentMethod]) === null || _k === void 0 ? void 0 : _k.length));
        });
    });
};
